import { render, staticRenderFns } from "./BuzonSugerenciaPublicComponent.vue?vue&type=template&id=2668a3ac&"
import script from "./BuzonSugerenciaPublicComponent.vue?vue&type=script&lang=js&"
export * from "./BuzonSugerenciaPublicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports